import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { PURGE } from 'redux-persist'
import { getItemTagDetails } from '../../../api/inventory/get-item-tag-details'

/* Initial state of the slice */
const initialState = {
  isFetchingItemTags: false,
  itemTags: [],
  fetchItemTagsError: null,
}

/* Handler for making service call to fetch tags for a specific item */
export const fetchItemTags = createAsyncThunk(
  'itemTag/fetchItemTags',
  async (args, { getState, rejectWithValue }) => {
    const state = getState()
    const request = {
      itemNumber: state.inventory.selectedInventoryItem.itemNumber.replaceAll('#', '%23'),
    }
    try {
      const response = await getItemTagDetails(request)
      return response?.data?.data
    } catch (exception) {
      return rejectWithValue(exception)
    }
  },
)

const itemTagSlice = createSlice({
  name: 'itemTag',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchItemTags.pending, (state) => {
        state.isFetchingItemTags = true
        state.itemTags = []
        state.fetchItemTagsError = null
      })
      .addCase(fetchItemTags.fulfilled, (state, action) => {
        state.isFetchingItemTags = false
        state.itemTags = action.payload
      })
      .addCase(fetchItemTags.rejected, (state, action) => {
        state.isFetchingItemTags = false
        state.fetchItemTagsError = action.payload
      })
      /* When fetching inventory items is in progress, reset item Tags */
      .addCase('inventory/fetchInventoryItems/pending', (state) => {
        state.itemTags = []
      })
      .addCase(PURGE, () => {
        return initialState
      })
  },
})

export default itemTagSlice.reducer
